var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppFresco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#001E36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1621 14.4297H31.2568V20.3132H20.0449V24.5684H29.9614V30.4519H20.0449V39.2214H13.1621L13.1621 14.4297ZM40.544 19.573C42.0615 19.573 43.2822 19.7581 43.8374 19.9431V24.9753C43.3936 24.8645 42.5425 24.7905 41.8394 24.7905C40.4702 24.7905 39.6934 24.9014 38.9902 25.1604V39.2214H32.5147V21.2012C34.8457 20.1651 37.1768 19.573 40.544 19.573Z",
    fill: "#31A8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppFresco);
export default __webpack_public_path__ + "static/media/B_app_Fresco.d53a519c218918c9568dfc0776ee033e.svg";
export { ForwardRef as ReactComponent };